"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrandingId = getBrandingId;
exports.getHomeUrl = getHomeUrl;
exports.getJWT = getJWT;
exports.getLang = getLang;
exports.getLangMode = getLangMode;
exports.getOSHCacheIdentifier = getOSHCacheIdentifier;
exports.getSessionId = getSessionId;
exports.getTheme = getTheme;
exports.getXpdConfigOptionsForAsset = getXpdConfigOptionsForAsset;
function getJWT(state) {
  return state.JWT.token;
}
function getSessionId(state) {
  return state.userPrefs.sessionId;
}
function getHomeUrl(state) {
  var _state$nuiPage;
  return (_state$nuiPage = state.nuiPage) === null || _state$nuiPage === void 0 || (_state$nuiPage = _state$nuiPage.header) === null || _state$nuiPage === void 0 || (_state$nuiPage = _state$nuiPage.headerProps) === null || _state$nuiPage === void 0 || (_state$nuiPage = _state$nuiPage.menuData) === null || _state$nuiPage === void 0 || (_state$nuiPage = _state$nuiPage.homeMenuItem) === null || _state$nuiPage === void 0 ? void 0 : _state$nuiPage.url;
}
function getLang(state) {
  var _state$userPrefs;
  return (_state$userPrefs = state.userPrefs) === null || _state$userPrefs === void 0 || (_state$userPrefs = _state$userPrefs.localeData) === null || _state$userPrefs === void 0 ? void 0 : _state$userPrefs.lang;
}
function getLangMode(state) {
  var _state$userPrefs2;
  return (_state$userPrefs2 = state.userPrefs) === null || _state$userPrefs2 === void 0 || (_state$userPrefs2 = _state$userPrefs2.localeData) === null || _state$userPrefs2 === void 0 ? void 0 : _state$userPrefs2.langMode;
}
function getOSHCacheIdentifier(state) {
  var _state$userPrefs3;
  var sessionId = getSessionId(state);
  return "".concat((_state$userPrefs3 = state.userPrefs) === null || _state$userPrefs3 === void 0 ? void 0 : _state$userPrefs3.loginName, "-").concat(sessionId === null || sessionId === void 0 ? void 0 : sessionId.slice(-6));
}
function getBrandingId(state) {
  var _state$nuiPage2;
  return (_state$nuiPage2 = state.nuiPage) === null || _state$nuiPage2 === void 0 ? void 0 : _state$nuiPage2.brandingId;
}
function getTheme(state) {
  var _state$nuiPage3;
  return (_state$nuiPage3 = state.nuiPage) === null || _state$nuiPage3 === void 0 ? void 0 : _state$nuiPage3.theme;
}
function getXpdConfigOptionsForAsset(state, key) {
  var xpdConfigOptions = state.xpdConfigOptions || {};
  var asset = xpdConfigOptions[key] || {};
  return asset.configOptions;
}